<template>
  <v-container fluid>
    <v-card class="mt-5 mx-auto pa-3" style="max-width: 700px">
      <div class="d-flex align-center pa-4" style="border-radius: 6px; background-color: #f1e6e4">
        <v-icon class="mr-2">mdi-face-man-profile</v-icon>
        <span class="text-h6">Informações do Perfil</span>
      </div>
      <small>Nome</small>
      <v-text-field outlined v-model="usuario.usuario"></v-text-field>
      <small>CPF</small>
      <v-text-field outlined readonly v-model="usuario.cpf"></v-text-field>
      <small>E-mail</small>
      <v-text-field outlined v-model="usuario.email"></v-text-field>
      <v-btn color="primary" class="mt-4 mr-2" large @click="salvarPerfil">
        <v-icon left>mdi-content-save</v-icon>
        Salvar
      </v-btn>
      <v-btn color="deep-orange accent-2" class="mt-4" large @click="abrirModalSenha">
        <v-icon left>mdi-lock-reset</v-icon>
        Alterar Senha
      </v-btn>
      <v-dialog v-model="modalSenha" max-width="400">
        <v-card>
          <v-card-title class="headline">Alterar Senha</v-card-title>
          <v-card-text>
            <small>Nova Senha</small>
            <v-text-field
              outlined
              ref="novaSenhaField"
              v-model="novaSenha"
              type="password"
              autocomplete="new-password"
            ></v-text-field>
            <small>Confirmar Senha</small>
            <v-text-field
              outlined
              ref="confirmaSenhaField"
              v-model="confirmaSenha"
              type="password"
              autocomplete="new-password"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="salvarNovaSenha">
              <v-icon left>mdi-content-save</v-icon>
              Salvar
            </v-btn>
            <v-btn color="deep-orange accent-2" @click="modalSenha = false">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="loading" persistent max-width="300">
        <v-card color="primary" dark>
          <v-card-text class="d-flex flex-column align-center justify-center pa-8">
            <v-progress-circular indeterminate color="white" size="48" class="mb-4" />
            <span class="text-h6">Aguarde...</span>
            <small class="mt-2">Processando solicitação</small>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card>
  </v-container>
</template>

<script>
//import { Libs } from "@/libs/libs";
import filtros from "@/libs/filters";
import { mapGetters } from "vuex";
import CredenciamentoServices from "@/services/acesso/CredenciamentoServices";

export default {
  name: "PerfilUsuario",
  data() {
    return {
      modalSenha: false,
      novaSenha: "",
      confirmaSenha: "",
      loading: false,
    };
  },
  components: {},
  filters: filtros,
  computed: {
    ...mapGetters({
      usuario: "login/getDadosUsuario",
    }),
  },
  methods: {
    salvarPerfil() {
      this.loading = true;
      CredenciamentoServices.updateUsuario(this.usuario)
        .then((resp) => {
          this.loading = false;
          if (resp.success) {
            this.$toast?.success(resp.message || "Perfil salvo com sucesso!");
          } else if (resp.Error) {
            this.$toast?.error(resp.Error || "Erro ao salvar perfil!");
          }
        })
        .catch(() => {
          this.loading = false;
          this.$toast?.error("Erro ao salvar perfil!");
        });
    },
    abrirModalSenha() {
      this.novaSenha = "";
      this.confirmaSenha = "";
      this.$nextTick(() => {
        if (this.$refs.novaSenhaField) this.$refs.novaSenhaField.$refs.input.value = "";
        if (this.$refs.confirmaSenhaField) this.$refs.confirmaSenhaField.$refs.input.value = "";
        this.modalSenha = true;
      });
    },
    async salvarNovaSenha() {
      if (!this.novaSenha || !this.confirmaSenha) {
        this.$toast?.error("Preencha todos os campos!");
        return;
      }
      if (this.novaSenha !== this.confirmaSenha) {
        this.$toast?.error("As senhas não conferem!");
        return;
      }
      this.loading = true;
      try {
        const resp = await CredenciamentoServices.updateSenhaUsuario({
          novaSenha: this.novaSenha,
          confirmaSenha: this.confirmaSenha,
        });
        this.loading = false;
        if (resp.success) {
          this.$toast?.success(resp.message || "Senha alterada com sucesso!");
          this.modalSenha = false;
        } else if (resp.Error) {
          this.$toast?.error(resp.Error || "Erro ao alterar senha!");
        }
      } catch (e) {
        this.loading = false;
        this.$toast?.error("Erro ao alterar senha!");
      }
    },
  },
  mounted: function () {},
};
</script>
